import { createSelector } from "reselect"
import { get } from "lodash"
import { getCurrentPerformance } from "./performance"
import { getDisplayCategories } from "./data"
import { getFactorCategoryId, getCategories } from "./items"
import { computeSelectedOption } from "helpers/analyze"

const EMPTY_ARRAY = []

export const getOptions = createSelector(
  [getCurrentPerformance, getCategories, getDisplayCategories],
  (current, categories, displayCategories) => {
    if (current) {
      const options = [{
        id: "total",
        color: "#00abe8",
        label: "Total",
        value: current.total,
      }, {
        id: "factors",
        color: "#9067a7",
        label: "Factors",
        value: current.factorsTotal,
      },
      ...categories
        .filter(category => !category.singleFactor)
        .map(category => {
          if (displayCategories.indexOf(category.id) === -1) return null

          const field = `categories.${category.id}`
          const value = get(current, field)

          return { value, ...category }
        }),
      ]

      // filter out options for which there's no value
      return options.filter(option => option && !Number.isNaN(option.value))
    } else {
      return EMPTY_ARRAY
    }
  },
)

export const getSelectedOption = createSelector(
  [getOptions, getFactorCategoryId],
  computeSelectedOption,
)
